import React, { useState } from "react";
import { DetailProcessProps } from "Data/detail";
import styled from "styled-components";
import Indecator from "Components/Indecator";
import SliderList from "./SliderList";
import theme from "Styles/theme";
import useSliderCount from "Hooks/useSliderCount";
import BtnIcon from "./Btn/BtnIcon";
import media from "Styles/media";
import TextParagraph from "./Text/TextParagraph";

interface SliderProps {
	data: DetailProcessProps[];
	className?: string;
}

const Wrapper = styled.div``;

const SliderWrapper = styled.ul`
	${(props) => props.theme.layout.ratio(theme.size.ratio.source)};
	position: relative;
`;

const Inner = styled.ul`
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;

	display: flex;
	overflow-y: hidden;
	overflow-x: scroll;
	scroll-snap-type: x mandatory;
	${(props) => props.theme.layout.scroll_hide};
	scroll-behavior: smooth;
`;

const List = styled(SliderList)`
	width: 100%;
	flex-shrink: 0;
	scroll-snap-align: center;
`;

const BtnWrapper = styled.div<{ active: boolean }>`
	display: ${(props) => (props.active ? "block" : "none")};
	@media ${media.touch} {
		display: none;
	}
`;
const BtnDefault = styled(BtnIcon)`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	z-index: 5;
`;
const BtnLeft = styled(BtnDefault)`
	left: 32px;
`;
const BtnRight = styled(BtnDefault)`
	right: 32px;
`;

const NoteWrapper = styled.div`
	width: 100%;
	overflow: hidden;
`;
const NoteInner = styled.ul<{ count: number; nowCount: number }>`
	display: flex;
	transform: ${(props) => `translateX(-${100 * props.nowCount}%)`};
	transition: ${(props) => props.theme.transition.default};
`;
const Note = styled(TextParagraph)`
	width: 100%;
	flex-shrink: 0;
	flex-grow: 0;
	padding: 16px 0;
`;

const Slider: React.FC<SliderProps> = ({ data, className }) => {
	const { count, slider, indecatorClicked, slideUp, slideDown } = useSliderCount();
	const [isVideoPlay, setIsVideoPlay] = useState(false);

	return (
		<Wrapper className={className}>
			<SliderWrapper className={"slider-container"}>
				<BtnWrapper active={!isVideoPlay}>
					{count !== 0 && <BtnLeft icon={"left"} hoverBgColor={theme.color.bg} bgColor={theme.color.gray.light} onClick={slideDown} />}
					{count !== data.length - 1 && <BtnRight icon={"right"} hoverBgColor={theme.color.bg} bgColor={theme.color.gray.light} onClick={slideUp} />}
				</BtnWrapper>
				<Inner ref={slider}>
					{data.map((el) => (
						<List data={el} key={el.id} setIsVideoPlay={setIsVideoPlay} />
					))}
				</Inner>
			</SliderWrapper>
			<NoteWrapper>
				<NoteInner count={data.length} nowCount={count}>
					{data.map((el, index) => {
						return <Note value={el.note ? `${el.note}` : " - "} key={index} />;
					})}
				</NoteInner>
			</NoteWrapper>
			<Indecator nowCount={count} count={data.length} onClick={indecatorClicked} />
		</Wrapper>
	);
};

export default Slider;
